import { Pipe, PipeTransform } from '@angular/core';
import { PermissionAssignee } from '../model/permissions/permissions.model';
import { PermissionsHelper } from './permissions.helper';

@Pipe({
    name: 'permissionAssigneeName',
    standalone: false
})
export class PermissionAssigneeNamePipe implements PipeTransform {

  transform(permissionAssignee: PermissionAssignee): string {
    return PermissionsHelper.getAssigneeName(permissionAssignee);
  }

}
